import styled from "styled-components";

export const ListContent = styled.div`
    display: block;
    width: 100%;
    height: calc(100% - 278px);
    background-color: white;
    padding: 0;
`;

export const ListHeader = styled.div`
    display: block;
    width: 100%;
    font-size: 18px;
    border-bottom: 2px solid #173A6D;
    padding-bottom: 8px;
    color: ${props => props.theme.colors.textBold};
    font-weight: 700;
`;

export const ListBody = styled.div`
    height: calc(100% - 37px);
    overflow: auto;
`;

